// extracted by mini-css-extract-plugin
module.exports = {"Login--form--link":"LoginForm_Login--form--link__fFLW4"};